import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, fonts, spacing, borderRadius } from '../../../constants';

/**
 * TestimonialCard Component
 * Displays a testimonial/quote card
 * 
 * @param {string} quote - Quote text
 * @param {string} author - Author name
 */
const TestimonialCard = ({ quote, author }) => {
  return (
    <Box
      sx={{
        flex: 1,
        backgroundColor: 'rgba(255, 255, 255, 0.12)',
        backdropFilter: 'blur(16px) saturate(180%)',
        WebkitBackdropFilter: 'blur(16px) saturate(180%)',
        borderRadius: borderRadius.lg,
        padding: spacing.sm,
        border: '1px solid rgba(255, 255, 255, 0.25)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.3)',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        animation: 'slideInRight 0.6s ease-out 0.6s both',
        '@keyframes slideInRight': {
          from: {
            opacity: 0,
            transform: 'translateX(30px)',
          },
          to: {
            opacity: 1,
            transform: 'translateX(0)',
          },
        },
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          boxShadow: '0 16px 48px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.4)',
          transform: 'translateY(-2px)',
          border: '1px solid rgba(255, 255, 255, 0.35)',
        },
      }}
    >
      <Typography
        sx={{
          fontSize: fonts.fontSizeSm,
          color: colors.textWhite,
          fontStyle: 'italic',
          mb: spacing.xs,
          lineHeight: 1.6,
          textAlign: 'left',
          fontWeight: fonts.weightMedium,
          textShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
        }}
      >
        "{quote || 'Loading...'}"
      </Typography>
      <Typography
        sx={{
          fontSize: fonts.fontSizeXs,
          color: colors.textWhite,
          textAlign: 'left',
          opacity: 0.95,
          textShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
          fontWeight: fonts.weightMedium,
        }}
      >
        — {author || 'Loading...'}
      </Typography>
    </Box>
  );
};

export default TestimonialCard;
